module.exports = __webpack_public_path__ + "static/media/backpack.98ec199e.svg";